import React from 'react';
import getFluidGatsbyImage from 'hooks/getFluidGatsbyImage';
import RichTextImage from '../RichTextImage';

const RichTextEmbeddedAsset = ({ node }) => {
  const file = node?.data?.target?.fields?.file['en-US'];

  if (!file) {
    return null;
  }

  const { url, contentType, fileName, details } = file;
  const fluidsrc = {
    fluid: getFluidGatsbyImage({ file: { contentType, url, details } }, { toFormat: 'webp' }),
  };

  if (contentType.includes('image') || contentType.includes('png')) {
    return <RichTextImage src={fluidsrc?.fluid ? fluidsrc : url} alt={fileName} />;
  } else {
    return null;
  }
};

export default RichTextEmbeddedAsset;
